import { BasePresenter } from '../base/base.presenter';
import { useSelector } from 'react-redux';
import { Utilities, String, Dictionary } from '@utils';
import { ILang } from '@models/*';
import { dxDataGridColumn } from 'devextreme/ui/data_grid';
import { IDataGridOptions } from 'devextreme-react/data-grid';
import { IProaService, ProaService } from '@services/proyecta/proa-form.service';
import { IProaDetails } from '@interfaces/screens/detail-proa-summary.interface';
import { kill } from 'process';
import { Children } from 'react';
import { stringIsNullOrEmpty } from '@pnp/common';
import moment from 'moment';


export class DetailsProaPresenter extends BasePresenter<IProaDetails> { 
    private service: IProaService;
    private data: any;
    private formMasters: any;
    public dataSource: any;
    public currentLang: ILang;
    public currentLabels: Dictionary<string, string>;

    constructor(view: IProaDetails) {
        super(view);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
        this.currentLang = useSelector(this.context.sessionStore.selectLang);
        this.service = new ProaService();
    }

    //#region Init Report
    public async initReport(){        
        await this.getAllData();
        const data = await this.mappingData();
        const projectsGrouped = await this.service.getAllProjectsGrouped()
        this.getDataSource(data, projectsGrouped);
    }
    private async getAllData(){
        this.data = await this.service.getAllProa();
        this.formMasters = await this.service.getAllFormMasters(this.currentLang.label);
    }
    //#endregion

    //#region Get  All Data

    private async mappingData():Promise<any>{
        const result = await Promise.all([
            this.mappingBasicData(),
            this.distinctDetails(),
            this.getFFRRSteps(),
            this.getFFCCSteps()
        ]);
        return {
            projects: result[0],
            subProjects: result[1],
            ffrrData: result[2],
            ffccData: result[3]
        }
    }
    private mappingBasicData(){
        const dataMapped = this.data.budgets.map((project:any) => {  
            const region = project.OCTAVIARegionId != null ? this.formMasters.regions.find((x:any) => x.Id == project.OCTAVIARegionId) : project.OCTAVIARegionId;
            const country = project.OCTAVIAPaisId != null ? this.formMasters.countries.find((x:any) => x.Id == project.OCTAVIAPaisId) : project.OCTAVIAPaisId;          
            const rrhh = this.data.rrhh.find((x:any) => x.PPresPresupuestoId == project.Id);
            const labels = this.data.fSteps.base.find((x:any) => x.PPresPresupuestoId == project.Id);
            const strLine = this.formMasters.interventionLines.find((x:any)=>x.Id == project.OCTAVIALineaIntervencionId);
            return {
                id: project.Id,
                parentid: project.PPresPresupuestoId,
                region: region?.Title || this.formMasters.regions.find((x:any) => x.Id == country?.OCTAVIARegionId)?.Title || String.Empty || String.Empty,
                country: country?.Title || String.Empty,
                projectTitle: project?.Title || String.Empty,
                projectCode: project?.CodigoProyecto?.Title || String.Empty,
                projectManager: rrhh?.PRGIdentificacionGerente0 || String.Empty,
                projectAdmin: rrhh?.PRGIdentificacionAdministrador0 || String.Empty,
                labels: labels ? labels.OCTAVIAEtiquetasId.map((label:any)=>{
                    return this.formMasters.tags.find((y:any)=>y.Id == label)?.Title || String.Empty
                }).join(', ') : String.Empty,
                strategicLines: strLine?.Title || String.Empty,
                strategicLinesCode: strLine?.OCTAVIACodigo || String.Empty
            }
        });
        return dataMapped;
    }
    private distinctDetails(){
        const groupedDetails: any[] = [];        
        this.data.details.forEach((detail:any) => {
            const itemInGroup = groupedDetails.find((gp:any) => gp.projectId == detail.PPresPresupuestoId);
            const insert = (itemInGroup == null || itemInGroup == undefined);
            if(insert){
                const ffrr = this.data.details.filter((x:any)=> (
                    (x.PPresPresupuestoId == detail.PPresPresupuestoId) &&
                    (x.PPresCodSubvencionId == null || x.PPresCodSubvencionId == undefined || x.PPresCodSubvencionId == 0)
                ));
                const ffcc = this.data.details.filter((x:any)=> (
                    (x.PPresPresupuestoId == detail.PPresPresupuestoId) &&
                    (x.PPresCodSubvencionId != null && x.PPresCodSubvencionId != undefined &&  x.PPresCodSubvencionId != 0)
                ));
                
                if(ffrr.length > 0){
                    const newDetailFFRR: any = {};
                    newDetailFFRR.projectId =  detail.PPresPresupuestoId;
                    newDetailFFRR.subProaType = "FFRR"
                    newDetailFFRR.subvCode = String.Empty;
                    newDetailFFRR.financers = this.groupedToString({
                        data: ffrr,
                        master: this.formMasters.ffrrFinancer,
                        parameterCompare: 'OCTAVIAFinanciadorSapId',
                        parameterResult: 'Title'
                    });
                    groupedDetails.push(newDetailFFRR);
                }else{
                    const newDetailFFRR: any = {};
                    newDetailFFRR.projectId =  detail.PPresPresupuestoId;
                    newDetailFFRR.subProaType = "FFRR"
                    newDetailFFRR.subvCode = String.Empty;
                    newDetailFFRR.financers = String.Empty;
                    groupedDetails.push(newDetailFFRR);
                }
                
                if(ffcc.length > 0){
                    const newDetailFFCC: any = {};
                    newDetailFFCC.projectId =  detail.PPresPresupuestoId;
                    newDetailFFCC.subProaType = "FFCC";
                    newDetailFFCC.subInfo = [];
                    ffcc.forEach((item:any) => {
                        const subvCode = this.formMasters.grantCodes.find((x:any)=>x.Id == item.PPresCodSubvencionId)?.Title || String.Empty;
                        const financer = this.formMasters.ffccFinancer.find((x:any)=>x.Id == item.OCTAVIAFinanciadorSapId)?.Title || String.Empty;                        
                        const control = subvCode.substring(0,1) != "A"
                        const detail = newDetailFFCC.subInfo.find((x:any)=> x.subvCode == subvCode);
                        if(control){
                            if(detail != undefined){
                                if(detail.financer != financer){
                                    detail.financer = String.Format('{0}, {1}',detail.financer, financer)
                                }                            
                            }else{
                                const newDetail = {
                                    subvCode: subvCode,
                                    financer: financer,
                                    subvCodeId: item.PPresCodSubvencionId
                                }
                                newDetailFFCC.subInfo.push(newDetail);
                            }
                        }
                    });
                    groupedDetails.push(newDetailFFCC);
                }
            }
        });
        return groupedDetails;
    }
    private getFFRRSteps(){
        const ffrrData = {
            base: this.data.fSteps.step1.base.filter((x:any) => x.PPresCodSubvencionId == null),            
            implementers: this.data.fSteps.step2.base.filter((x:any) => x.PPresCodSubvencionId == null),
            locations: this.data.fSteps.step3.base.filter((x:any) => x.PPresCodSubvencionId == null),
            objetives: this.data.fSteps.step4.objetivos,
            mri: this.data.fSteps.step4.mri
        };

        const allProjects: Array<any> = [];   
          
        ffrrData.base.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                });
            }
            
        });
        ffrrData.implementers.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                });
            } 
        });
        ffrrData.locations.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                });
            }
        });
        ffrrData.objetives.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                });
            } 
        });
        const result: Array<any> = [];
        allProjects.forEach((x:any) => {
            const base = ffrrData.base.find((y:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null );
            const implementers = ffrrData.implementers.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null );
            const locations = ffrrData.locations.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null );
            const objetives = ffrrData.objetives.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  y.PPresCodSubvencionId == null );
            const ffrrItem = {     
                id: base?.Id,           
                projectId: x.projectId,
                projectType: "FFRR",
                ...base ? this.mappingBaseLine(base,this.data.fSteps.step1.years):{
                    startDate: String.Empty,
                    endDate: String.Empty,
                    baseLine: String.Empty,
                    PProaAnioLineaBase: String.Empty,
                    strategicLineInd: {
                        strategicLineInd: String.Empty ,
                        years: this.data.fSteps.step1.years.filter((year:any) => year.PProaFRStep1Id == base?.Id || 0),
                        max: this.data.fSteps.step1.yearsMax,
                        min: this.data.fSteps.step1.yearsMin
                    },
                },
                total: base?.PPresTotalAnio || 0,
                ...this.mappingBeneficiaries(base?.Id,this.data.fSteps.step1.yearsBeneficiaries, null, this.data.fSteps.step1),
                implementers: {
                    values: this.mappingImplementers(x.projectId,implementers,this.data.fSteps.step2.years),
                    max: this.data.fSteps.step2.yearsMax,
                    min: this.data.fSteps.step2.yearsMin
                },
                locations:{
                    values:this.mappingLocations(x.projectId,locations,this.data.fSteps.step3.years),
                    max: this.data.fSteps.step3.yearsMax,
                    min: this.data.fSteps.step3.yearsMin
                },
                objetives: this.mappingObjetives(objetives, this.data.fSteps.step4),
                mri: {
                    values: ffrrData.mri.base.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId ),
                    years: this.data.fSteps.step4.mri.years,
                    max: this.data.fSteps.step4.mri.yearsMax,
                    min: this.data.fSteps.step4.mri.yearsMin
                }
            }
            result.push(ffrrItem);
        });
        return result;
    }
    private getFFCCSteps(){
        const ffccData = {
            base: this.data.fSteps.step1.base.filter((x:any) => x.PPresCodSubvencionId != null && x.PPresCodSubvencionId != undefined),            
            implementers: this.data.fSteps.step2.base.filter((x:any) => x.PPresCodSubvencionId != null && x.PPresCodSubvencionId != undefined),
            locations: this.data.fSteps.step3.base.filter((x:any) => x.PPresCodSubvencionId != null && x.PPresCodSubvencionId != undefined),
            objetives: this.data.fSteps.step4.objetivos,
            mri: this.data.fSteps.step4.mri
        };
        const allProjects: Array<any> = [];   
          
        ffccData.base.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                    subvCode: y.PPresCodSubvencionId
                });
            }
            
        });
        ffccData.implementers.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                    subvCode: y.PPresCodSubvencionId
                });
            } 
        });
        ffccData.locations.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                    subvCode: y.PPresCodSubvencionId
                });
            }
        });
        ffccData.objetives.forEach((y:any) => { 
            const item = allProjects.find((x:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId)
            if(item == undefined || item == null){
                allProjects.push({
                    projectId: y.PPresPresupuestoId,
                    subvCode: y.PPresCodSubvencionId
                });
            } 
        });
        
        const result: Array<any> = [];
        allProjects.forEach((x:any) => {
            const base = ffccData.base.find((y:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId );
            const implementers = ffccData.implementers.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId );
            const locations = ffccData.locations.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId );
            const objetives = ffccData.objetives.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId );
            const mri = ffccData.mri.base.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId );
            const ffccItem = {     
                id: base?.Id,           
                projectId: x.projectId,
                projectType: "FFCC",
                suvbCode: x.subvCode,
                ...base ? this.mappingBaseLine(base,this.data.fSteps.step1.years):{
                    startDate: String.Empty,
                    endDate: String.Empty,
                    baseLine: String.Empty,
                    PProaAnioLineaBase: String.Empty,
                    strategicLineInd: {
                        strategicLineInd: String.Empty ,
                        years: this.data.fSteps.step1.years.filter((year:any) => year.PProaFRStep1Id == base?.Id || 0),
                        max: this.data.fSteps.step1.yearsMax,
                        min: this.data.fSteps.step1.yearsMin
                    },
                },
                total: base?.PPresTotalAnio || 0,
                ...this.mappingBeneficiaries(base?.Id,this.data.fSteps.step1.yearsBeneficiaries, null, this.data.fSteps.step1),
                implementers: {
                    values: this.mappingImplementers(x.projectId,implementers,this.data.fSteps.step2.years),
                    max: this.data.fSteps.step2.yearsMax,
                    min: this.data.fSteps.step2.yearsMin
                },
                locations:{
                    values:this.mappingLocations(x.projectId,locations,this.data.fSteps.step3.years),
                    max: this.data.fSteps.step3.yearsMax,
                    min: this.data.fSteps.step3.yearsMin
                },
                objetives: this.mappingObjetives(objetives, this.data.fSteps.step4),
                mri: {
                    values: ffccData.mri.base.filter((y:any) => x.projectId == y.PPresPresupuestoId &&  x.subvCode == y.PPresCodSubvencionId ),
                    years: this.data.fSteps.step4.mri.years,
                    max: this.data.fSteps.step4.mri.yearsMax,
                    min: this.data.fSteps.step4.mri.yearsMin
                }
            }
            
            result.push(ffccItem);
        });
        return result;
    }
    //#endregion

    //#region Proccess Data

    private getDataSource(data: any, projectsGrouped: any){
        const dataSource:any = [];
        const projectData = this.groupedProjects(data);
        projectData.forEach((project:any) => {            
            const ffrr = data.ffrrData.find((x:any)=>x.projectId == project.id);      
            if (ffrr == undefined){
                const childRow: any = { ...project };
                delete childRow.childs;
                childRow.Id = project.id
                childRow.totalgoalStrategicLineInd = 0;
                //dataSource.push(childRow);
            }
            if (project.childs.length > 0) {
                project.childs.filter((x: any) => x.subProaType == "FFRR").forEach((child: any) => {
                    const childRow: any = { ...project };
                    delete childRow.childs;
                    const header: any = {};
                    const beneficiaresData: any = {};
                    const strategicLineData: any = {};
                    const specificObjetive: any = {};
                    const specificObjetiveIndicator: any = {};
                    const mriData: any = {};
                    header.Id = project.id;
                    header.projectType = child.subProaType;
                    header.startDate = ffrr?.startDate || String.Empty;
                    header.endDate = ffrr?.endDate || String.Empty;
                    header.subvCode = child.subvCode;
                    header.financers = child.financers;
                    header.implementators = ffrr ? ffrr.implementers.values.map((x: any) => { return x.slep }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                    header.localizations = ffrr ? ffrr.locations.values.map((x: any) => { return x.location }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                    header.adts = ffrr ? ffrr.locations.values.map((x: any) => { return x.adt }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                    strategicLineData.strategicLineIndDescription = ffrr ? ffrr.strategicLineInd.strategicLineInd.description : String.Empty;
                    strategicLineData.strategicLineIndCode = ffrr ? ffrr.strategicLineInd.strategicLineInd.code : String.Empty;
                    strategicLineData.baseLine = ffrr ? ffrr.baseLine : String.Empty;
                    strategicLineData.PProaAnioLineaBase = ffrr ? ffrr.PProaAnioLineaBase : String.Empty;
                    if (ffrr != undefined) {
                        const len = ffrr.strategicLineInd.max;
                        let total = 0;
                        let index = ffrr.strategicLineInd.min;
                        for (index; index < len + 1; index++) {
                            const parameterName = String.Format("goalStrategicLineInd-{0}", index.toString());
                            const value = ffrr.strategicLineInd.years.find((value: any) => value.PPresAnioMeta == index);
                            strategicLineData[parameterName] = value?.PProaAnioValue || 0;
                            total += strategicLineData[parameterName];
                        }
                        strategicLineData.totalgoalStrategicLineInd = total;
                        strategicLineData.totalGoalBaseLine = ffrr.finalGoal;

                        const lenB = ffrr.beneficiaries.max;
                        let indexB = ffrr.beneficiaries.min;
                        for (indexB; indexB < lenB + 1; indexB++) {
                            const parameterNameT = String.Format("TotalBeneficiaries-{0}", indexB.toString());
                            const parameterNameH = String.Format("TotalBeneficiariesMan-{0}", indexB.toString());
                            const parameterNameM = String.Format("TotalBeneficiariesWoman-{0}", indexB.toString());
                            const value = ffrr.beneficiaries.years.find((value: any) => parseInt(value.PPresuAnio) == indexB );

                            beneficiaresData[parameterNameT] = value?.PPresTotalAnio || 0;
                            beneficiaresData[parameterNameH] = value?.PFFRRTotalHombres || 0;
                            beneficiaresData[parameterNameM] = value?.PFRRTotalMujeres || 0;
                        }
                    }
                    dataSource.push({ ...childRow, ...header, ...beneficiaresData, ...strategicLineData });

                    if (ffrr?.mri?.values.length > 0) {
                            ffrr.mri.values.forEach((result: any) => {
                                const indicadorMriPr = this.formMasters.productsIndicators.find((x:any) => x.Id === result.PFFRRIndicadorProductoId);
                                const indicadorMriLE = this.formMasters.strategicLines.find((x:any) => x.Id === result.PPresIndicadorLineaEstrategicaId);
                                const indicadorMriRI = this.formMasters.intermediateResultsIndicator.find((x:any) => x.Id === result.PFFRRIndicadorResultadoIntermediId[0]);

                                mriData.PProaDescripcion = result.PProaDescripcion;
                                mriData.PFFRRLineaBase = result.PFFRRLineaBase;
                                mriData.PProaAnioLineaBaseMRI = result.PProaAnioLineaBase;
                                mriData.PProaMetaMRI = result.PProaMetaMRI;
                                mriData.IndicadorMriPR = result.PFFRRIndicadorProductoId ? indicadorMriPr?.Title : String.Empty;
                                mriData.IndicadorMriLE = result.PPresIndicadorLineaEstrategicaId ? indicadorMriLE?.Title : String.Empty;
                                mriData.IndicadorMriRI = result.PFFRRIndicadorResultadoIntermediId ? indicadorMriRI?.Title : String.Empty;
                                const len = ffrr.mri.max;
                                let index = ffrr.mri.min;
                                for (index; index < len + 1; index++) {
                                    const parameterName = String.Format("metaMri-{0}", index.toString());
                                    const value = ffrr.mri.years.find((value: any) => value.PPresAnioMeta == index && value.PProaStep4AdaptacionMRIId === result.Id);
                                    mriData[parameterName] = value?.PProaAnioValue || 0;
                                }
                                dataSource.push({
                                ...childRow,
                                ...header,
                                ...mriData,
                            });
                            })
                        }
                        if (ffrr?.objetives.length > 0) {

                            ffrr.objetives.forEach((result: any) => {
                                specificObjetive.specificObjetive = result.specificObjetive;
                                result.specificObjetiveIndicators?.forEach((indicator: any) => {
                                    specificObjetiveIndicator.specificObjetiveIndicator = indicator.indicator;
                                    specificObjetiveIndicator.objetiveBaseLine = indicator.baseLine
                                    specificObjetiveIndicator.objetivefinalGoalFinancer = indicator.finalGoalFinancer;
                                    specificObjetiveIndicator.PProaMedidaOE = indicator.base?.PProaMedida?.Title;
                                    specificObjetiveIndicator.PProaAnioLineaBaseOE = indicator.PProaAnioLineaBase;
                                    if (indicator.base) {
                                        const len = indicator.yearsMax;
                                        let index = indicator.yearsMin;
                                        for (index; index < len + 1; index++) {
                                            const parameterName = String.Format("goalObjective-{0}", index.toString());
                                            const value = indicator.years.find((value: any) => value.PPresAnioMeta == index);
                                            specificObjetiveIndicator[parameterName] = value?.PProaAnioValue || 0;
                                        }
                                    }
                                    dataSource.push({
                                        ...childRow,
                                        ...header,
                                        ...specificObjetiveIndicator,
                                        ...specificObjetive
                                    });
                                });
                                result.expectedResult?.forEach((result: any) => {
                                    const expectedResult: any = {};
                                    expectedResult.expectedResult = result.expectedResult;
                                    result.expectedResultIndicator.forEach((indicator: any) => {
                                        const expectedResultIndicator: any = {};
                                        expectedResultIndicator.expectedResultIndicator = indicator.expectedResultIndicator;
                                        expectedResultIndicator.expectedResultBaseLine = indicator.baseLine;
                                        expectedResultIndicator.expectedResultfinalGoalFinancer = indicator.finalGoalFinancer;
                                        expectedResultIndicator.PProaMedidaRE = indicator.base?.PProaMedida?.Title;
                                        expectedResultIndicator.PProaAnioLineaBaseRE = indicator.PProaAnioLineaBase;
                                        if (indicator.base) {
                                            const len = indicator.yearsMax;
                                            let index = indicator.yearsMin;
                                            for (index; index < len + 1; index++) {
                                                const parameterName = String.Format("goalResult-{0}", index.toString());
                                                const value = indicator.years.find((value: any) => value.PPresAnioMeta == index);
                                                expectedResultIndicator[parameterName] = value?.PProaAnioValue || 0;
                                            }
                                        }
                                        dataSource.push({
                                            ...childRow,
                                            ...header,
                                            ...expectedResultIndicator,
                                            ...expectedResult,
                                            ...specificObjetive
                                        });
                                    });
                                    result.activities?.forEach((activity: any) => {
                                        const activities: any = {};
                                        activities.activity = activity.activity;
                                        activities.finalBudgetActivity = activity.finalBudgetActivity;
                                        activities.PProaMedidaAC = activity.base?.PProaMedida?.Title || String.Empty;
                                        activities.PProaMetaTotalProyecto = activity.base?.PProaMetaTotalProyecto;
                                        const len = activity.yearsMax;
                                        let index = activity.yearsMin;
                                        for (index; index < len + 1; index++) {
                                            const parameterName = String.Format("goalActivityBudget-{0}", index.toString());
                                            const parameterNameA = String.Format("goalActivity-{0}", index.toString());
                                            const value = activity.years.find((value: any) => value.PPresAnioMeta == index);
                                            activities[parameterName] = value?.PProaAnioValue || 0;
                                            activities[parameterNameA] = value?.PFFRRSubTotal || 0;
                                        }
                                        dataSource.push({
                                            ...childRow,
                                            ...header,
                                            ...expectedResult,
                                            ...activities,
                                            ...specificObjetive
                                        });
                                    });
                                    
                                });
                            });
                        }

                });
                project.childs.filter((x: any) => x.subProaType == "FFCC").forEach((child: any) => {

                    const childRow: any = { ...project };
                    delete childRow.childs;
                    const header: any = {};
                    const beneficiaresData: any = {};
                    const strategicLineData: any = {};
                    const specificObjetive: any = {};
                    const specificObjetiveIndicator: any = {};
                    const mriData: any = {};

                    header.Id = project.id;

                    header.projectType = child.subProaType;
                    child.subInfo.forEach((item: any) => {
                        let isPpalGrouped = projectsGrouped.find((y: any) => (y.PPresPresupuestoId == project.id && y.PPresCodSubvencionId === item.subvCodeId))
                        let isGrouped = projectsGrouped.find((z: any) => z.SubProyectosAgrupadosId?.length && z.SubProyectosAgrupadosId.includes(item.subvCodeId))
                        if(!isGrouped){
                            const ffcc = data.ffccData.find((x: any) => x.projectId == project.id && x.suvbCode == item.subvCodeId);
                            let infoGrouped = [{subvCode: item.subvCode, financer: item.financer}]
                            if(isPpalGrouped){
                                infoGrouped[0].subvCode = infoGrouped[0].subvCode + ' *';
                                isPpalGrouped.SubProyectosAgrupadosId.forEach((codeId: any) => {
                                    let aux = child.subInfo.find((ch: any) => ch.subvCodeId == codeId );
                                    if(aux) infoGrouped.push({subvCode: aux.subvCode, financer: aux.financer})
                                });
                            }
                          
                            header.startDate = ffcc?.startDate || String.Empty;
                            header.endDate = ffcc?.endDate || String.Empty;
                            header.subvCode = infoGrouped?.length ? infoGrouped.map(x => x.subvCode).join(', ') : String.Empty;
                            header.financers = infoGrouped?.length ? infoGrouped.map(x => x.financer).join(', ') : String.Empty;
                            header.implementators = ffcc ? ffcc.implementers.values.map((x: any) => { return x.slep }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                            header.localizations = ffcc ? ffcc.locations.values.map((x: any) => { return x.location }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                            header.adts = ffcc ? ffcc.locations.values.map((x: any) => { return x.adt }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                            strategicLineData.strategicLineIndDescription = ffcc ? ffcc.strategicLineInd.strategicLineInd.description : String.Empty;
                            strategicLineData.strategicLineIndCode = ffcc ? ffcc.strategicLineInd.strategicLineInd.code : String.Empty;
                            strategicLineData.baseLine = ffcc ? ffcc.baseLine : String.Empty;
                            strategicLineData.PProaAnioLineaBase = ffcc ? ffcc.PProaAnioLineaBase : String.Empty;
                            if (ffcc != undefined) {
                                const len = ffcc.strategicLineInd.max;
                                let total = 0;
                                let index = ffcc.strategicLineInd.min;
                                for (index; index < len + 1; index++) {
                                    const parameterName = String.Format("goalStrategicLineInd-{0}", index.toString());
                                    const value = ffcc.strategicLineInd.years.find((value: any) => value.PPresAnioMeta == index);
                                    strategicLineData[parameterName] = value?.PProaAnioValue || 0;
                                    total += strategicLineData[parameterName];
                                }
                                strategicLineData.totalgoalStrategicLineInd = total;
                                strategicLineData.totalGoalBaseLine = ffcc.finalGoal;

                                const lenB = ffcc.beneficiaries.max;
                                let indexB = ffcc.beneficiaries.min;
                                for (indexB; indexB < lenB + 1; indexB++) {
                                    const parameterNameT = String.Format("TotalBeneficiaries-{0}", indexB.toString());
                                    const parameterNameH = String.Format("TotalBeneficiariesMan-{0}", indexB.toString());
                                    const parameterNameM = String.Format("TotalBeneficiariesWoman-{0}", indexB.toString());
                                    const value = ffcc.beneficiaries.years.find((value: any) => parseInt(value.PPresuAnio) == indexB );

                                    beneficiaresData[parameterNameT] = value?.PPresTotalAnio || 0;
                                    beneficiaresData[parameterNameH] = value?.PFFRRTotalHombres || 0;
                                    beneficiaresData[parameterNameM] = value?.PFRRTotalMujeres || 0;
                                }
                            }
                            dataSource.push({ ...childRow, ...header, ...beneficiaresData, ...strategicLineData });
                            if (ffcc?.mri?.values.length > 0) {
                                ffcc.mri.values.forEach((result: any) => {
                                    const indicadorMriPr = this.formMasters.productsIndicators.find((x:any) => x.Id === result.PFFRRIndicadorProductoId);
                                    const indicadorMriLE = this.formMasters.strategicLines.find((x:any) => x.Id === result.PPresIndicadorLineaEstrategicaId);
                                    const indicadorMriRI = this.formMasters.intermediateResultsIndicator.find((x:any) => x.Id === result.PFFRRIndicadorResultadoIntermediId[0]);

                                    mriData.PProaDescripcion = result.PProaDescripcion;
                                    mriData.PFFRRLineaBase = result.PFFRRLineaBase;
                                    mriData.PProaAnioLineaBaseMRI = result.PProaAnioLineaBase;
                                    mriData.PProaMetaMRI = result.PProaMetaMRI;
                                    mriData.IndicadorMriPR = result.PFFRRIndicadorProductoId ? indicadorMriPr?.Title : String.Empty;
                                    mriData.IndicadorMriLE = result.PPresIndicadorLineaEstrategicaId ? indicadorMriLE?.Title : String.Empty;
                                    mriData.IndicadorMriRI = result.PFFRRIndicadorResultadoIntermediId ? indicadorMriRI?.Title : String.Empty;
                                    const len = ffcc.mri.max;
                                    let index = ffcc.mri.min;
                                    for (index; index < len + 1; index++) {
                                        const parameterName = String.Format("metaMri-{0}", index.toString());
                                        const value = ffcc.mri.years.find((value: any) => value.PPresAnioMeta == index && value.PProaStep4AdaptacionMRIId === result.Id);
                                        mriData[parameterName] = value?.PProaAnioValue || 0;
                                    }
                                    dataSource.push({
                                    ...childRow,
                                    ...header,
                                    ...mriData,
                                });
                                })
                            }
                            if (ffcc?.objetives.length > 0) {

                                ffcc.objetives.forEach((result: any) => {
                                    specificObjetive.specificObjetive = result.specificObjetive;
                                    result.specificObjetiveIndicators?.forEach((indicator: any) => {
                                        specificObjetiveIndicator.specificObjetiveIndicator = indicator.indicator;
                                        specificObjetiveIndicator.objetiveBaseLine = indicator.baseLine
                                        specificObjetiveIndicator.objetivefinalGoalFinancer = indicator.finalGoalFinancer;
                                        specificObjetiveIndicator.PProaMedidaOE = indicator.base?.PProaMedida?.Title;
                                        specificObjetiveIndicator.PProaAnioLineaBaseOE = indicator.PProaAnioLineaBase;
                                        if (indicator.base) {
                                            const len = indicator.yearsMax;
                                            let index = indicator.yearsMin;
                                            for (index; index < len + 1; index++) {
                                                const parameterName = String.Format("goalObjective-{0}", index.toString());
                                                const value = indicator.years.find((value: any) => value.PPresAnioMeta == index);
                                                specificObjetiveIndicator[parameterName] = value?.PProaAnioValue || 0;
                                            }
                                        }
                                        dataSource.push({
                                            ...childRow,
                                            ...header,
                                            ...specificObjetiveIndicator,
                                            ...specificObjetive
                                        });
                                    });
                                    result.expectedResult?.forEach((result2: any) => {
                                        const expectedResult: any = {};
                                        expectedResult.expectedResult = result2.expectedResult;
                                        result2.expectedResultIndicator.forEach((indicator: any) => {
                                            const expectedResultIndicator: any = {};
                                            expectedResultIndicator.expectedResultIndicator = indicator.expectedResultIndicator;
                                            expectedResultIndicator.expectedResultBaseLine = indicator.baseLine;
                                            expectedResultIndicator.expectedResultfinalGoalFinancer = indicator.finalGoalFinancer;
                                            expectedResultIndicator.PProaMedidaRE = indicator.base?.PProaMedida?.Title;
                                            expectedResultIndicator.PProaAnioLineaBaseRE = indicator.PProaAnioLineaBase;
                                            if (indicator.base) {
                                                const len = indicator.yearsMax;
                                                let index = indicator.yearsMin;
                                                for (index; index < len + 1; index++) {
                                                    const parameterName = String.Format("goalResult-{0}", index.toString());
                                                    const value = indicator.years.find((value: any) => value.PPresAnioMeta == index);
                                                    specificObjetiveIndicator[parameterName] = value?.PProaAnioValue || 0;
                                                }
                                            }
                                            dataSource.push({
                                                ...childRow,
                                                ...header,
                                                ...specificObjetiveIndicator,
                                                ...specificObjetive,
                                                ...expectedResult,
                                                ...expectedResultIndicator
                                            });
                                        });
                                        
                                        result2.activities?.forEach((activity: any) => {
                                            const activities: any = {};
                                            activities.activity = activity.activity;
                                            activities.finalBudgetActivity = activity.finalBudgetActivity;
                                            activities.PProaMedidaAC = activity.base?.PProaMedida?.Title || String.Empty;
                                            activities.PProaMetaTotalProyecto = activity.base?.PProaMetaTotalProyecto;
                                            const len = activity.yearsMax;
                                            let index = activity.yearsMin;
                                            for (index; index < len + 1; index++) {
                                                const parameterName = String.Format("goalActivityBudget-{0}", index.toString());
                                                const parameterNameA = String.Format("goalActivity-{0}", index.toString());
                                                const value = activity.years.find((value: any) => value.PPresAnioMeta == index);
                                                activities[parameterName] = value?.PProaAnioValue || 0;
                                                activities[parameterNameA] = value?.PFFRRSubTotal || 0;
                                            }
                                            dataSource.push({
                                                ...childRow,
                                                ...header,
                                                ...expectedResult,
                                                ...specificObjetive,
                                                ...activities
                                            })
                                        });                                        
                                    });
                                })
                            }
                        }
                    });
                });
            } else {
                const childRow: any = { ...project };
                delete childRow.childs;
                const header: any = {};
                const beneficiaresData: any = {};
                const strategicLineData: any = {};
                const specificObjetive: any = {};
                const specificObjetiveIndicator: any = {};
                const mriData: any = {};

                header.Id = project.id;
                header.projectType = ffrr?.projectType;
                header.startDate = ffrr?.startDate || String.Empty;
                header.endDate = ffrr?.endDate || String.Empty;
                header.subvCode = String.Empty;
                header.financers = String.Empty;
                header.implementators = ffrr ? ffrr.implementers.values.map((x: any) => { return x.slep }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                header.localizations = ffrr ? ffrr.locations.values.map((x: any) => { return x.location }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                header.adts = ffrr ? ffrr.locations.values.map((x: any) => { return x.adt }).filter((y: any) => y != String.Empty).join(',') : String.Empty;
                strategicLineData.strategicLineIndDescription = ffrr ? ffrr.strategicLineInd.strategicLineInd.description : String.Empty;
                strategicLineData.strategicLineIndCode = ffrr ? ffrr.strategicLineInd.strategicLineInd.code : String.Empty;
                strategicLineData.baseLine = ffrr ? ffrr.baseLine : String.Empty;
                strategicLineData.PProaAnioLineaBase = ffrr ? ffrr.PProaAnioLineaBase : String.Empty;
                if (ffrr != undefined) {
                    const len = ffrr.strategicLineInd.max;
                    let total = 0;
                    let index = ffrr.strategicLineInd.min;
                    for (index; index < len + 1; index++) {
                        const parameterName = String.Format("goalStrategicLineInd-{0}", index.toString());
                        const value = ffrr.strategicLineInd.years.find((value: any) => value.PPresAnioMeta == index);
                        strategicLineData[parameterName] = value?.PProaAnioValue || 0;
                        total += strategicLineData[parameterName];
                    }
                    strategicLineData.totalgoalStrategicLineInd = total;
                    strategicLineData.totalGoalBaseLine = ffrr.finalGoal;

                    const lenB = ffrr.beneficiaries.max;
                    let indexB = ffrr.beneficiaries.min;
                    for (indexB; indexB < lenB + 1; indexB++) {
                        const parameterNameT = String.Format("TotalBeneficiaries-{0}", indexB.toString());
                        const parameterNameH = String.Format("TotalBeneficiariesMan-{0}", indexB.toString());
                        const parameterNameM = String.Format("TotalBeneficiariesWoman-{0}", indexB.toString());
                        const value = ffrr.beneficiaries.years.find((value: any) => parseInt(value.PPresuAnio) == indexB );

                        beneficiaresData[parameterNameT] = value?.PPresTotalAnio || 0;
                        beneficiaresData[parameterNameH] = value?.PFFRRTotalHombres || 0;
                        beneficiaresData[parameterNameM] = value?.PFRRTotalMujeres || 0;
                    }
                }
                dataSource.push({ ...childRow, ...header, ...beneficiaresData, ...strategicLineData });
                
                if (ffrr?.mri?.values.length > 0) {
                    ffrr.mri.values.forEach((result: any) => {
                        const indicadorMriPr = this.formMasters.productsIndicators.find((x:any) => x.Id === result.PFFRRIndicadorProductoId);
                        const indicadorMriLE = this.formMasters.strategicLines.find((x:any) => x.Id === result.PPresIndicadorLineaEstrategicaId);
                        const indicadorMriRI = this.formMasters.intermediateResultsIndicator.find((x:any) => x.Id === result.PFFRRIndicadorResultadoIntermediId[0]);
                        mriData.PProaDescripcion = result.PProaDescripcion;
                        mriData.PFFRRLineaBase = result.PFFRRLineaBase;
                        mriData.PProaAnioLineaBaseMRI = result.PProaAnioLineaBase;
                        mriData.PProaMetaMRI = result.PProaMetaMRI;
                        mriData.IndicadorMriPR = result.PFFRRIndicadorProductoId ? indicadorMriPr?.Title : String.Empty;
                        mriData.IndicadorMriLE = result.PPresIndicadorLineaEstrategicaId ? indicadorMriLE?.Title : String.Empty;
                        mriData.IndicadorMriRI = result.PFFRRIndicadorResultadoIntermediId ? indicadorMriRI?.Title : String.Empty;
                        const len = ffrr.mri.max;
                        let index = ffrr.mri.min;
                        for (index; index < len + 1; index++) {
                            const parameterName = String.Format("metaMri-{0}", index.toString());
                            const value = ffrr.mri.years.find((value: any) => value.PPresAnioMeta == index && value.PProaStep4AdaptacionMRIId === result.Id);
                            mriData[parameterName] = value?.PProaAnioValue || 0;
                        }
                        dataSource.push({
                        ...childRow,
                        ...header,
                        ...mriData,
                    });
                    })
                }
                if (ffrr?.objetives.length > 0) {

                    ffrr.objetives.forEach((result: any) => {
                        specificObjetive.specificObjetive = result.specificObjetive;
                        result.specificObjetiveIndicators?.forEach((indicator: any) => {
                            specificObjetiveIndicator.specificObjetiveIndicator = indicator.indicator;
                            specificObjetiveIndicator.objetiveBaseLine = indicator.baseLine
                            specificObjetiveIndicator.objetivefinalGoalFinancer = indicator.finalGoalFinancer;
                            specificObjetiveIndicator.PProaMedidaOE = indicator.base?.PProaMedida?.Title;
                            specificObjetiveIndicator.PProaAnioLineaBaseOE = indicator.PProaAnioLineaBase;
                            if (indicator.base) {
                                const len = indicator.yearsMax;
                                let index = indicator.yearsMin;
                                for (index; index < len + 1; index++) {
                                    const parameterName = String.Format("goalObjective-{0}", index.toString());
                                    const value = indicator.years.find((value: any) => value.PPresAnioMeta == index);
                                    specificObjetiveIndicator[parameterName] = value?.PProaAnioValue || 0;
                                }
                            }
                            dataSource.push({
                                ...childRow,
                                ...header,
                                ...specificObjetiveIndicator,
                                ...specificObjetive
                            });
                        });
                        result.expectedResult?.forEach((result: any) => {
                            const expectedResult: any = {};
                            expectedResult.expectedResult = result.expectedResult;
                            result.expectedResultIndicator.forEach((indicator: any) => {
                                const expectedResultIndicator: any = {};
                                expectedResultIndicator.expectedResultIndicator = indicator.expectedResultIndicator;
                                expectedResultIndicator.expectedResultBaseLine = indicator.baseLine;
                                expectedResultIndicator.expectedResultfinalGoalFinancer = indicator.finalGoalFinancer;
                                expectedResultIndicator.PProaMedidaRE = indicator.base?.PProaMedida?.Title;
                                expectedResultIndicator.PProaAnioLineaBaseRE = indicator.PProaAnioLineaBase;
                                if (indicator.base) {
                                    const len = indicator.yearsMax;
                                    let index = indicator.yearsMin;
                                    for (index; index < len + 1; index++) {
                                        const parameterName = String.Format("goalResult-{0}", index.toString());
                                        const value = indicator.years.find((value: any) => value.PPresAnioMeta == index);
                                        expectedResultIndicator[parameterName] = value?.PProaAnioValue || 0;
                                    }
                                }
                                dataSource.push({
                                    ...childRow,
                                    ...header,
                                    ...expectedResultIndicator,
                                    ...expectedResult,
                                    ...specificObjetive
                                });
                            });
                            result.activities?.forEach((activity: any) => {
                                const activities: any = {};
                                activities.activity = activity.activity;
                                activities.finalBudgetActivity = activity.finalBudgetActivity;
                                activities.PProaMedidaAC = activity.base?.PProaMedida?.Title || String.Empty;
                                activities.PProaMetaTotalProyecto = activity.base?.PProaMetaTotalProyecto;
                                const len = activity.yearsMax;
                                let index = activity.yearsMin;
                                for (index; index < len + 1; index++) {
                                    const parameterName = String.Format("goalActivityBudget-{0}", index.toString());
                                    const parameterNameA = String.Format("goalActivity-{0}", index.toString());
                                    const value = activity.years.find((value: any) => value.PPresAnioMeta == index);
                                    activities[parameterName] = value?.PProaAnioValue || 0;
                                    activities[parameterNameA] = value?.PFFRRSubTotal || 0;
                                }
                                dataSource.push({
                                    ...childRow,
                                    ...header,
                                    ...expectedResult,
                                    ...activities,
                                    ...specificObjetive
                                });
                            });
                        });
                    });
                }
            }

        });
        this.view.state.setYearsRange(this.getYearsRange());
        this.getAllColumnsDefinitions();
        this.view.state.setDataSource(dataSource);
    }
    public async getAllColumnsDefinitions() {
    this.dispatcherProgress(50);
        if (!Utilities.isNullObject(this.currentLang)) {
            const columns = await this.service.getDetailsFieldsDefinition(
                this.currentLang.id
            );
            let fieldColumns = this.fields(this.data, columns)
            this.view.state.setFieldsColumns(fieldColumns)
            this.view.state.setDataColumns(columns);
        }
    }
    public getFields(columns:any, fieldName: string) {
        if (Utilities.isNullObject(columns)) return String.Empty;
        return (
            columns.get(fieldName)?.NombreColumna ?? String.Empty
        );
    }
    public fields(data:any, columns:any): dxDataGridColumn[] {
        if(Utilities.isNullObject(this.data)){
            return []
        }else
        return <dxDataGridColumn[]>[
            {
                caption: 'ID',
                dataField: 'Id',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'REGION'),
                dataField: 'region',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'PAIS'),
                dataField: 'country',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'TITULO PROYECTO'),
                dataField: 'projectTitle',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'CODIGO PROYECTO'),
                dataField: 'projectCode',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'GERENTE DEL PROYECTO'),
                dataField: 'projectManager',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ADMINISTRADOR DEL PROYECTO'),
                dataField: 'projectAdmin',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'TIPO SUBPROYECTO'),
                dataField: 'projectType',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
              {
                caption: this.getFields(columns, 'FECHA DE INICIO'),
                dataField: 'startDate',
                visible: true,
                dataType: 'string',
                alignment:'center'
                
            },
            {
                caption: this.getFields(columns, 'FECHA DE FIN'),
                dataField: 'endDate',
                visible: true,
                dataType: 'string',
                alignment:'center'
            },
            {
                caption: this.getFields(columns, 'CODIGO SUBVENCION'),
                dataField: 'subvCode',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ETIQUETAS'),
                dataField: 'labels',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'IMPLEMENTADORES'),
                dataField: 'implementators',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'LOCALIZACIONES'),
                dataField: 'localizations',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ADT'),
                dataField: 'adts',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            ...this.getYearsColumns(columns, data, "beneficiaryPopulation", 'POBLACION BENEFICIARIA TOTAL', 'TotalBeneficiaries'),
            ...this.getYearsColumns(columns, data, "beneficiaryPopulation", 'POBLACION BENEFICIARIA HOMBRES', 'TotalBeneficiariesMan'),
            ...this.getYearsColumns(columns, data, "beneficiaryPopulation", 'POBLACION BENEFICIARIA MUJERES', 'TotalBeneficiariesWoman'),
            {
                caption: this.getFields(columns, 'DESCRIPCION LINEA ESTRATEGICA'),
                dataField: 'strategicLines',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'CODIGO LINEA ESTRATEGICA'),
                dataField: 'strategicLinesCode',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'DESCRIPCION INDICADOR LINEA ESTRATEGICA'),
                dataField: 'strategicLineIndDescription',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'CODIGO INDICADOR LINEA ESTRATEGICA'),
                dataField: 'strategicLineIndCode',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'LINEA DE BASE IND. LINEA ESTRATEGICA'),
                dataField: 'baseLine',
                visible: true,
                dataType: 'number',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ANIO LINEA BASE LINEA ESTRATEGICA'),
                dataField: 'PProaAnioLineaBase',
                visible: true,
                dataType: 'date',
                format: 'MM/dd'
            },
            {
                caption: this.getFields(columns, 'META FINAL IND. LINEA ESTRATEGICA'),
                dataField: 'totalGoalBaseLine',
                visible: true,
                dataType: 'number',
                alignment: 'center'
            },
            ...this.getYearsColumns(columns, data, "strategicLineData"),
            {
                caption: this.getFields(columns, 'OBJETIVO ESPECIFICO'),
                dataField: 'specificObjetive',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'INDICADOR OBJETIVO ESPECIFICO'),
                dataField: 'specificObjetiveIndicator',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            ...this.getYearsColumns(columns, data, "goalObjective"),
            {
                caption: this.getFields(columns, 'LINEA DE BASE IND. OBJETIVO ESPECIFICO'),
                dataField: 'objetiveBaseLine',
                visible: true,
                dataType: 'number',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ANIO LINEA BASE OBJETIVO ESPECIFICO'),
                dataField: 'PProaAnioLineaBaseOE',
                visible: true,
                dataType: 'date',
                format: 'MM/dd'
            },
            {
                caption: this.getFields(columns, 'MEDIDA OBJETIVO ESPECIFICO'),
                dataField: 'PProaMedidaOE',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'META FINAL FINANCIADOR IND. OBJETIVO ESPECIFICO'),
                dataField: 'objetivefinalGoalFinancer',
                visible: true,
                dataType: 'number',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'RESULTADO ESPERADO'),
                dataField: 'expectedResult',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'INDICADOR RESULTADO ESPERADO'),
                dataField: 'expectedResultIndicator',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            ...this.getYearsColumns(columns, data, "goalResult"),
            {
                caption: this.getFields(columns, 'LINEA DE BASE IND. RESULTADO ESPERADO'),
                dataField: 'expectedResultBaseLine',
                visible: true,
                dataType: 'number',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ANIO LINEA BASE RESULTADO ESPERADO'),
                dataField: 'PProaAnioLineaBaseRE',
                visible: true,
                dataType: 'date',
                format: 'MM/dd'
            },
            {
                caption: this.getFields(columns, 'MEDIDA RESULTADO ESPERADO'),
                dataField: 'PProaMedidaRE',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'META FINAL FINANCIADOR IND. RESULTADO ESPERADO'),
                dataField: 'expectedResultfinalGoalFinancer',
                visible: true,
                dataType: 'number',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ACTIVIDAD'),
                dataField: 'activity',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'PRESUPUESTO TOTAL ACTIVIDAD'),
                dataField: 'finalBudgetActivity',
                visible: true,
                dataType: 'number',
                format: '€ #,##0.##; € #,#0'
            },
            ...this.getYearsColumns(columns, data, "goalActivityBudget"),
            {
                caption: this.getFields(columns, 'META TOTAL ACTIVIDAD'),
                dataField: 'PProaMetaTotalProyecto',
                visible: true,
                dataType: 'number',
            },
            ...this.getYearsColumns(columns, data, "goalActivity"),
            {
                caption: this.getFields(columns, 'MEDIDA ACTIVIDAD'),
                dataField: 'PProaMedidaAC',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'DESCRIPCION MRI'),
                dataField: 'PProaDescripcion',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'INDICADOR MRI PRODUCTO'),
                dataField: 'IndicadorMriPR',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'INDICADOR MRI RESULTADO INTERMEDIO'),
                dataField: 'IndicadorMriRI',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'INDICADOR MRI LINEA ESTRATEGICA'),
                dataField: 'IndicadorMriLE',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
            ...this.getYearsColumns(columns, data, "metaMri"),
            {
                caption: this.getFields(columns, 'LINEA BASE MRI'),
                dataField: 'PFFRRLineaBase',
                visible: true,
                dataType: 'number',
                alignment: 'center'
            },
            {
                caption: this.getFields(columns, 'ANIO LINEA BASE MRI'),
                dataField: 'PProaAnioLineaBaseMRI',
                visible: true,
                dataType: 'date',
                format: 'MM/dd'
            },
            {
                caption: this.getFields(columns, 'META PROYECTO MRI'),
                dataField: 'PProaMetaMRI',
                visible: true,
                dataType: 'string',
                alignment: 'center'
            },
        ];
    }
    private getYearsColumns(columnsAux:any, data:any, section: string, field: string = "", dataField: string = "") {
        const columns: Array<any> = []
        const limits: any = {
            max: 0,
            min: 0
        }
        switch (section) {
            case "strategicLineData":
                limits.max = data.fSteps.step1.yearsMax;
                limits.min = data.fSteps.step1.yearsMin;
                const columnLabelME = this.getFields(columnsAux, 'META IND. LINEA ESTRATEGICA');
                for (let index = limits.min; index < limits.max + 1; index++) {
                    const column: any = {};
                    column.caption = String.Format(`${columnLabelME} {0}`, index);
                    column.dataField = String.Format('goalStrategicLineInd-{0}', index);
                    column.visible = true;
                    column.dataType = 'number';
                    column.alignment = 'center';
                    columns.push(column);
                }
                break;
            case "beneficiaryPopulation":
                limits.max = this.data.fSteps.step1.beneficiariesMax;
                limits.min = this.data.fSteps.step1.benficiaresMin;
                const columnLabelBE = this.getFields(columnsAux, field);
                for (let index = limits.min; index < limits.max + 1; index++) {
                    const column: any = {};
                    column.caption = String.Format(`${columnLabelBE} {0}`, index);
                    column.dataField = String.Format(`${dataField}-{0}`, index);
                    column.visible = true;
                    column.dataType = 'number';
                    column.alignment = 'center';
                    columns.push(column);
                }
                break;
            case "goalObjective":
                limits.max = data.fSteps.step4.objetivoEspecifico.yearsMax;
                limits.min = data.fSteps.step4.objetivoEspecifico.yearsMin;
                const columnLabelGO = this.getFields(columnsAux, 'META OBJETIVO');
                for (let index = limits.min; index < limits.max + 1; index++) {
                    const column: any = {};
                    column.caption = String.Format(`${columnLabelGO} {0}`, index);
                    column.dataField = String.Format('goalObjective-{0}', index);
                    column.visible = true;
                    column.dataType = 'number';
                    column.alignment = 'center';
                    columns.push(column);
                }
                break;
            case "goalResult":
                limits.max = data.fSteps.step4.resultado.yearsMax;
                limits.min = data.fSteps.step4.resultado.yearsMin;
                const columnLabelGR = this.getFields(columnsAux, 'META RESULTADO');
                for (let index = limits.min; index < limits.max + 1; index++) {
                    const column: any = {};
                    column.caption = String.Format(`${columnLabelGR} {0}`, index);
                    column.dataField = String.Format('goalResult-{0}', index);
                    column.visible = true;
                    column.dataType = 'number';
                    column.alignment = 'center';
                    columns.push(column);
                }
                break;
            case "goalActivityBudget":
                limits.max = data.fSteps.step4.actividad.yearsMax;
                limits.min = data.fSteps.step4.actividad.yearsMin;
                const columnLabelPA = this.getFields(columnsAux, 'PRESUPUESTO ACTIVIDAD');
                for (let index = limits.min; index < limits.max + 1; index++) {
                    const column: any = {};
                    column.caption = String.Format(`${columnLabelPA} {0}`, index);
                    column.dataField = String.Format('goalActivityBudget-{0}', index);
                    column.visible = true;
                    column.dataType = 'number';
                    column.alignment = 'center';
                    column.format = '€ #,##0.##; € #,#0';
                    columns.push(column);
                }
                break;
            case "goalActivity":
                limits.max = data.fSteps.step4.actividad.yearsMax;
                limits.min = data.fSteps.step4.actividad.yearsMin;
                const columnLabelMA = this.getFields(columnsAux, 'META ACTIVIDAD');
                for (let index = limits.min; index < limits.max + 1; index++) {
                    const column: any = {};
                    column.caption = String.Format(`${columnLabelMA} {0}`, index);
                    column.dataField = String.Format('goalActivity-{0}', index);
                    column.visible = true;
                    column.dataType = 'number';
                    column.alignment = 'center';
                    columns.push(column);
                }
                break;
            case "metaMri":
                limits.max = data.fSteps.step4.mri.yearsMax;
                limits.min = data.fSteps.step4.mri.yearsMin;
                const columnLabelMri = this.getFields(columnsAux, 'META MRI');
                for (let index = limits.min; index < limits.max + 1; index++) {
                    const column: any = {};
                    column.caption = String.Format(`${columnLabelMri} {0}`, index);
                    column.dataField = String.Format('metaMri-{0}', index);
                    column.visible = true;
                    column.dataType = 'number';
                    column.alignment = 'center';
                    columns.push(column);
                }
                break;
        }
        return columns;
    }
    private groupedProjects(data: any) {
        return data.projects.filter((x: any) => x.parentid == null || x.parentid == undefined).map((project: any) => {

            const childs = data.projects.filter((x: any) => x.parentid == project.id).map((child: any) => {
                return child.id;
            });

            const projectDetails = data.subProjects.filter((sub: any) => sub.projectId == project.id);

            childs.forEach((id: any) => {
                const details = data.subProjects.filter((sub: any) => sub.projectId == id);
                details.forEach((detail: any) => {
                    delete detail.projectId;
                    projectDetails.push(detail);
                });
            });
            const result: any = {
                ...project,
                childs: []
            }
            const ffrr: any = projectDetails.filter((detail: any) => detail.subProaType === "FFRR");
            const ffcc: any = projectDetails.filter((detail: any) => detail.subProaType === "FFCC");;

            if(ffrr.length > 0){
                result.childs.push(ffrr[0]);
            }

            if(ffcc.length > 0){         
                const ffccGroup:any = {subProaType:"FFCC", subInfo:[]};
                ffcc.forEach((x:any) => {
                    x.subInfo.forEach((y:any) => {
                        if(ffccGroup.subInfo.length === 0){
                            ffccGroup.subInfo.push(y);
                        }
                        const item = ffccGroup.subInfo.find((t:any) => t.subvCodeId === y.subvCodeId);
                        if(item === undefined){
                            ffccGroup.subInfo.push(y);
                        }else{
                            const financers = item.financer + ',' + y.financer;
                            const arrFinancers = financers.split(',').map((j:any) => {return j.trim()});
                            const distinctFinancer = arrFinancers.filter((value:any, index:number) => {
                                return arrFinancers.indexOf(value.trim()) === index;
                            });
                            item.financer = distinctFinancer.join(',');
                        }
                    });                    
                });
                result.childs.push(ffccGroup);
            }            
            return result;
        });
    }
    private groupedToString(options: any) {
        const results: Array<string> = [];
        options.data.forEach((detail: any) => {
            const item = options.master.find((master: any) => master.Id == detail[options.parameterCompare]);
            if (item != null && item != undefined) {
                if (results.indexOf(item[options.parameterResult]) === -1) {
                    results.push(item[options.parameterResult]);
                }
            }
        });
        return results.join(', ');
    }
    private mappingImplementers(id: Number | String, data: any[], years: any[]) {
        const implementers = data?.filter((y: any) => y.PPresPresupuestoId == id) || [];
        return implementers.length > 0 ? implementers.map((imp: any) => {
            return {
                id: imp.Id,
                slep: imp.OCTAVIASLEPId ? this.formMasters.implementators.find((x: any) => x.Id == imp.OCTAVIASLEPId)?.Title || String.Empty : String.Empty,
                total: imp.PProaImplementadorTotal,
                years: years.filter((year: any) => year.PProaFRStep2Id == imp.Id)
            }
        }) : implementers;
    }
    private mappingLocations(id: Number | String, data: any[], years: any[]) {
        const locations = data?.filter((y: any) => y.PPresPresupuestoId == id) || [];
        return locations.length > 0 ? locations.map((loc: any) => {
            return {
                id: loc.Id,
                adt: loc.PProaAdtId ? this.formMasters.proaAdt.find((adt: any) => adt.Id == loc.PProaAdtId)?.Title || String.Empty : String.Empty,
                location: loc.PProaLocationId ? this.formMasters.proaLocalization.find((lct: any) => lct.Id == loc.PProaLocationId)?.Title || String.Empty : String.Empty,
                total: loc.PFFRRTotal,
                years: years.filter((year: any) => year.PProaFRStep3Id == loc.Id)
            }
        }) : locations
    }
    private mappingBeneficiaries(id: Number | String, data: any[], staticYear?: string, minMax: any = null) {
        let beneficiariesData = data?.filter((year: any) => year.PProaFRStep1Id == id) || [];
        if (staticYear != null && staticYear != undefined) {
            beneficiariesData = data?.filter((year: any) => year.PProaFRStep1Id == id && year.PPresuAnio == staticYear) || [];
        }
        return{
            beneficiaries: {
                years: beneficiariesData,
                min: minMax.benficiaresMin,
                max: minMax.beneficiariesMax
            },
        }
    }
  
        private changeTimeZone(date: string, timeZone: string) {

            function get_date_format(str_date: string) {
    
              let full_date_substr = str_date.slice(0, -1);
    
              let full_date_split = full_date_substr.split("T");
    
         
    
              let date_split = full_date_split[0].split("-");
    
              let hour_split = full_date_split[1].split(":");
    
         
    
              return {
    
                year: Number(date_split[0]),
    
                month: Number(date_split[1]) - 1,
    
                day: Number(date_split[2]),
    
                hour: Number(hour_split[0]),
    
                minute: Number(hour_split[1]),
    
                second: Number(hour_split[2]),
    
              };
    
            }
    
         
    
            let { year, month, day, hour, minute, second } = get_date_format(date);
    
            let proc_date = new Date(year, month, day, hour, minute, second);
    
            let date_eu = proc_date.toLocaleString("eu-ES", { timeZone }).split(" ")[0];
    
         
    
            return date_eu;
    
          }
    
    private mappingBaseLine(data: any, years: any[], max?: any, min?: any) {
     
        let datstater;
        let datended;
        const datestar =data.OCTAVIAFechaInicio ? data.OCTAVIAFechaInicio  : String.Empty;
        const datendeds =data.OCTAVIAFechaFinalizacion ?data.OCTAVIAFechaFinalizacion : String.Empty;
        if(datestar !=  String.Empty){
            datstater= moment.utc(new Date(data.OCTAVIAFechaInicio)).tz('Europe/Madrid').format("DD-MM-YYYY")
        }
        if(datendeds !=  String.Empty){
            datended= moment.utc(new Date(data.OCTAVIAFechaFinalizacion)).tz('Europe/Madrid').format("DD-MM-YYYY")
        }
        const strategicLines = this.formMasters.strategicLines.find((stl: any) => stl.Id == data.PPresIndicadorLineaEstrategica1Id);
        return {
            
            startDate: datestar== String.Empty? String.Empty:moment.tz(datestar,'Europe/Madrid').format("YYYY-MM-DD"),
            endDate: datendeds== String.Empty? String.Empty:moment.tz(datendeds,'Europe/Madrid').format("YYYY-MM-DD"),
            baseLine: data.PFFRRLineaBase,
            PProaAnioLineaBase: data.PProaAnioLineaBase,
            strategicLineInd: {
                strategicLineInd: data.PPresIndicadorLineaEstrategica1Id ?
                    strategicLines ? {
                        description: strategicLines.Title,
                        code: strategicLines.OCTAVIACodigo
                    } : String.Empty : String.Empty,
                years: years.filter((year: any) => year.PProaFRStep1Id == data.Id),
                max: max ? max : this.data.fSteps.step1.yearsMax,
                min: min ? min : this.data.fSteps.step1.yearsMin
            },
            finalGoal: data.PProaMetaFinal,
            total: data.PPresTotalAnio,
        }
    }
    private mappingObjetives(data: any, step: any) {
        const result = data.map((objetive: any) => {
            const suvbCode = this.formMasters.grantCodes.find((x: any) => x.Id == objetive.PPresCodSubvencionId)?.Title || String.Empty;
            return {
                specificObjetive: objetive.PProaObjetivo,
                projectType: suvbCode ? "FFCC" : "FFRR",
                subvCode: suvbCode,
                specificObjetiveIndicators: step.objetivoEspecifico.base.filter((x: any) => x.PProaFEStep4Id == objetive.Id).map((indicator: any) => {
                    return {
                        base: indicator,
                        indicator: indicator.PProaIndicadorObjetivo || String.Empty,
                        baseLine: indicator.PFFRRLineaBase,
                        finalGoalFinancer: indicator.PProaMetaFinanciera || String.Empty,
                        PProaAnioLineaBase: indicator.PProaAnioLineaBase,
                        yearsMax: step.objetivoEspecifico.yearsMax,
                        yearsMin: step.objetivoEspecifico.yearsMin,
                        years: step.objetivoEspecifico.years.filter((y: any) => y.PProaFEStep4InidicadorId == indicator.Id)
                    }
                }),
                expectedResult: step.resultado.base.filter((x: any) => x.PProaFEStep4Id == objetive.Id).map((result: any) => {
                    return {
                        expectedResult: result.PProaResultadoEsperado,
                        expectedResultIndicator: step.resultado.detalle.filter((detail: any) => detail.PProaFEStep4ResultadosEsperadosId == result.Id).map((indicator: any) => {
                            return {
                                base: indicator,
                                expectedResultIndicator: indicator.PProaIndicadorResultadoEsperado,
                                PProaAnioLineaBase: indicator.PProaAnioLineaBase,
                                baseLine: indicator.PFFRRLineaBase,
                                finalGoalFinancer: indicator.PProaMetaFinanciera,
                                yearsMax: step.resultado.yearsMax,
                                yearsMin: step.resultado.yearsMin,
                                years: step.resultado.years.filter((year: any) => year.PProaFEStep4ResultadoDetalleId == indicator.Id)
                            }
                        }),
                        activities: step.actividad.base.filter((activity: any) => activity.PProaFEStep4ResultadosEsperadosId == result.Id).map((y: any) => {
                            return {
                                base:y,
                                id: y.Id,
                                activity: y.PProaActividad,
                                finalBudgetActivity: y.PProaValorActividad,
                                yearsMax: step.actividad.yearsMax,
                                yearsMin: step.actividad.yearsMin,
                                years: step.actividad.years.filter((year: any) => year.PProaFEStep4ActividadId == y.Id)
                            }
                        })

                    }
                })

            }

        });
        return result;
    }
    private getYearsRange() {
        let maxYear = Math.max(
            this.data.fSteps.step1.yearsMax,
            this.data.fSteps.step1.beneficiariesMax,
            this.data.fSteps.step4.resultado.yearsMax,
            this.data.fSteps.step4.objetivoEspecifico.yearsMax,
            this.data.fSteps.step4.actividad.yearsMax,
            this.data.fSteps.step4.mri.yearsMax
        );
        let minYear = Math.min(
            this.data.fSteps.step1.yearsMin,
            this.data.fSteps.step1.benficiaresMin,
            this.data.fSteps.step4.objetivoEspecifico.yearsMin,
            this.data.fSteps.step4.resultado.yearsMin,
            this.data.fSteps.step4.actividad.yearsMin,
            this.data.fSteps.step4.mri.yearsMin
        );
        let yearsRange = [minYear]
        for (let index = minYear; index < maxYear; index++) {
            yearsRange.push(index + 1)
        }
        return yearsRange
    }
    public changeRange(min: number, max: number, columns:any) {
        let newColumns:any = []
        if(columns){
            columns.map((column: any) => {
                let columnYear = column.dataField.length > 3 ? parseInt(column.dataField.substr(-4)) : 0
                if((!min || (min && columnYear >= min )) && (!max ||(max && columnYear <= max )) || isNaN(columnYear)){
                    newColumns.push(column)
                }
            })
        }
        return newColumns.length ? newColumns : null;
    }
    //#endregion

    public options: IDataGridOptions = {
        columns: [],
        dataSource: this.view.state.dataSource,
        filterPanel: { visible: true },
        filterRow: { visible: true },
        columnMinWidth: 150,
        export: {
            fileName: "Proa Details" + new Date(),
            enabled: true,
            excelFilterEnabled: true,
            excelWrapTextEnabled: true
        },
        onToolbarPreparing: (e: any) => {
            e.toolbarOptions.items.unshift({
                location: 'before',
                template: 'yearsRange'
            });
        }
    }
   
}